import * as React from 'react';
const SvgArrowDown = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width={20}
        height={20}
        fill='none'
        {...props}>
        <path
            fill='currentColor'
            d='M9.458 13.51V4.96a.53.53 0 0 1 .538-.543q.228 0 .387.156a.52.52 0 0 1 .159.387v8.55l2.035-2.035a.56.56 0 0 1 .383-.173.51.51 0 0 1 .391.163.55.55 0 0 1 .169.393.55.55 0 0 1-.177.383l-2.885 2.885a.62.62 0 0 1-.454.185.6.6 0 0 1-.25-.048.8.8 0 0 1-.219-.144L6.657 12.24a.5.5 0 0 1-.163-.369.57.57 0 0 1 .176-.386.52.52 0 0 1 .387-.168.55.55 0 0 1 .387.178z'
        />
    </svg>
);
export default SvgArrowDown;
